import { render, staticRenderFns } from "./HtmlReader.vue?vue&type=template&id=25f5904b"
import script from "./HtmlReader.vue?vue&type=script&lang=js"
export * from "./HtmlReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports